import { Form, Input, Typography } from 'antd';
import React from 'react';
import {
  FormStempContentProps,
  contentStyling,
  fieldIsRequired,
} from '../constants/constants';
import { inputHerePlaceholder } from '../constants/translations';
import { RegistrationFormRow } from './RegistrationFormRow';
import { BirthYearSelection } from './selectors/BirthYearSelection';
import { GradeSelection } from './selectors/GradeSelection';
import { Objectives } from './selectors/Objectives';
import { PeriodSelection } from './selectors/PeriodSelection';
import { ShoolYearSelection } from './selectors/ShoolYearSelection';
import { SubjectSelection } from './selectors/SubjectSelection';
import { SupGroupSelector } from './selectors/SupGroupSelector';
import { SupLevelSelector } from './selectors/SupLevelSelector';
import { SupSpecific } from './selectors/SupSpecific';
import { SupSubGroup } from './selectors/SupSubGroup';
import { SupSubSpecific } from './selectors/SupSubSpecific';
import { Tasks } from './selectors/Tasks';

type RegistrationFormProps = {
  specNeedsSubGroupOptions: string[];
  specNeedsSpecificOptions: string[];
  specNeedsSubSpecificOptions: string[];
} & FormStempContentProps;

export const RegistrationForm = React.memo(
  ({
    form,
    currentStep,
    specNeedsSubGroupOptions,
    specNeedsSpecificOptions,
    specNeedsSubSpecificOptions,
  }: RegistrationFormProps) => {
    return (
      <div
        style={{
          ...contentStyling,
          display: currentStep === 0 ? 'block' : 'none',
        }}
      >
        <Typography.Title
          style={{ marginTop: 0, marginBottom: 34, fontWeight: 'normal' }}
          level={4}
        >
          Pagrindiniai duomenys
        </Typography.Title>

        <RegistrationFormRow>
          <Form.Item
            label="Mokyklos pavadinimas"
            name={['registration', 'schoolName']}
            rules={[fieldIsRequired]}
          >
            <Input placeholder={inputHerePlaceholder} />
          </Form.Item>

          <Form.Item
            label="Mokinio (-ės) vardas, pavardė"
            name={['registration', 'student']}
            rules={[fieldIsRequired]}
          >
            <Input placeholder={inputHerePlaceholder} />
          </Form.Item>
        </RegistrationFormRow>

        <RegistrationFormRow>
          <ShoolYearSelection />
          <BirthYearSelection />
        </RegistrationFormRow>

        <RegistrationFormRow>
          <PeriodSelection />
          <Form.Item
            label="Pritaikytą programą rengė (vardas, pavardė)"
            name={['registration', 'eduSpecialist']}
          >
            <Input placeholder={inputHerePlaceholder} />
          </Form.Item>
        </RegistrationFormRow>

        <RegistrationFormRow>
          <GradeSelection />
          <SubjectSelection form={form} />
        </RegistrationFormRow>

        <RegistrationFormRow>
          <Objectives form={form} />
          <Tasks form={form} />
        </RegistrationFormRow>

        <RegistrationFormRow>
          <SupLevelSelector form={form} />
          <SupGroupSelector form={form} />
        </RegistrationFormRow>

        <RegistrationFormRow>
          <SupSubGroup
            form={form}
            selectionOptions={specNeedsSubGroupOptions}
          />
          <SupSpecific selectionOptions={specNeedsSpecificOptions} />
        </RegistrationFormRow>

        <RegistrationFormRow>
          <SupSubSpecific selectionOptions={specNeedsSubSpecificOptions} />
        </RegistrationFormRow>
      </div>
    );
  },
);
